import * as Actions from './constants'

const getStored = (key, defaultValue = null) => {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  } catch (err) {
    return defaultValue;
  }
};

const initState = {
  total: 0,
  locationMapData: {},
  locationData: [
    // {
    //   "address": {
    //     "line1": "8740 W Charleston Blvd. #4",
    //     "line2": "",
    //     "city": "Las Vegas",
    //     "state": "Nevada",
    //     "zipcode": "89117",
    //     "country": "United States"
    //   },
    //   "stationId": "LAS_VEGAS",
    //   "name": "Las Vegas",
    //   "timezone": "America/Los_Angeles",
    // },
    // {
    //   "address": {
    //     "line1": "150 E Broadway",
    //     "line2": "",
    //     "city": "Vista",
    //     "state": "California",
    //     "zipcode": "92084",
    //     "country": "United States"
    //   },
    //   "stationId": "VISTA_SAN_DIEGO",
    //   "name": "Vista San Diego",
    //   "timezone": "America/Los_Angeles"
    // },
    // {
    //   "address": {
    //     "line1": "150 E Broadway",
    //     "line2": "",
    //     "city": "Vista",
    //     "state": "California",
    //     "zipcode": "92084",
    //     "country": "United States"
    //   },
    //   "stationId": "VISTA_SAN_DIEGO",
    //   "name": "Costa Mesa, CA (coming soon!)",
    //   "timezone": "America/Los_Angeles"
    // },
    // {
    //   "address": {
    //     "line1": "150 E Broadway",
    //     "line2": "",
    //     "city": "Vista",
    //     "state": "California",
    //     "zipcode": "92084",
    //     "country": "United States"
    //   },
    //   "stationId": "VISTA_SAN_DIEGO",
    //   "name": "Fort Lauderdale, FL (coming soon!)",
    //   "timezone": "America/Los_Angeles"
    // },
  ],
  locationDashData: [],
  locationInfoData: [],
  serviceData: [],
  professionalData: [],
  timeSlotData: [],
  giftAmountData: [],
  bookData: getStored('bookData', null),
  selectedProfessional: getStored('selectedProfessional', null),
  selectedDate: getStored('selectedDate', null),
  selectedTime: getStored('selectedTime', null),
  selectedCardId: getStored('selectedCardId', null),
  isGroup: getStored('isGroup', ""),
  guests: getStored('guests', [{ id: 'user', name: 'Me', services: [] }]),
  activeGuestId: getStored('activeGuestId', 'user'),
  availableCoupons: [],
  membershipsData: [],
  bookingSessionId: getStored('bookingSessionId', null),
  bookingNotes: getStored('bookingNotes', ""),
}

export default function dataWebsiteReducer(state = initState, action = {}) {
  switch (action.type) {
    case Actions.TOTAL_DATA_GET:
      return {
        ...state,
        total: action.payload,
      }
    case Actions.LOCATION_DATA_GET:
      return {
        ...state,
        locationData: action.payload,
      }
    case Actions.LOCATION_MAP_DATA_GET:
      return {
        ...state,
        locationMapData: action.payload,
      }
    case Actions.SERVICE_DATA_GET:
      return {
        ...state,
        serviceData: action.payload,
      }
    case Actions.PROFESSIONAL_DATA_GET:
      return {
        ...state,
        professionalData: action.payload,
      }
    case Actions.BOOK_DATA_GET:
      localStorage.setItem('bookData', JSON.stringify(action.payload));
      return {
        ...state,
        bookData: action.payload,
      }
    case Actions.SELECTED_PROFESSIONAL_GET:
      localStorage.setItem('selectedProfessional', JSON.stringify(action.payload));
      return {
        ...state,
        selectedProfessional: action.payload,
      }
    case Actions.SELECTED_DATE_GET:
      localStorage.setItem('selectedDate', JSON.stringify(action.payload));
      return {
        ...state,
        selectedDate: action.payload,
      }
    case Actions.SELECTED_TIME_GET:
      localStorage.setItem('selectedTime', JSON.stringify(action.payload));
      return {
        ...state,
        selectedTime: action.payload,
      }
    case Actions.SELECTED_CARD_ID_GET:
      localStorage.setItem('selectedCardId', JSON.stringify(action.payload));
      return {
        ...state,
        selectedCardId: action.payload,
      }
    case Actions.IS_GROUP_GET:
      localStorage.setItem('isGroup', JSON.stringify(action.payload));
      return {
        ...state,
        isGroup: action.payload,
      }
    case Actions.AVAILABILITY_DATA_GET:
      return {
        ...state,
        timeSlotData: action.payload,
      }
    case Actions.GUESTS_DATA_GET:
      localStorage.setItem('guests', JSON.stringify(action.payload));
      return {
        ...state,
        guests: action.payload,
      }
    case Actions.ACTIVE_GUEST_ID_GET:
      localStorage.setItem('activeGuestId', JSON.stringify(action.payload));
      return {
        ...state,
        activeGuestId: action.payload,
      }
    case Actions.LOCATION_ID_GET:
      return {
        ...state,
        locationInfoData: action.payload,
      }
    case Actions.ORDER_ID_GET:
      return {
        ...state,
        orderData: action.payload,
      }
    case Actions.ORDERS_DATA_GET:
      return {
        ...state,
        orderDataList: action.payload,
      }
    case Actions.GIFT_AMOUNT_DATA_GET:
      return {
        ...state,
        giftAmountData: action.payload,
      }
    case Actions.COUPON_AVAILABLE_DATA_GET:
      return {
        ...state,
        availableCoupons: action.payload,
      }
    case Actions.MEMBERSHIPS_DATA_GET:
      return {
        ...state,
        membershipsData: action.payload,
      }
    case Actions.BOOKING_SESSION_ID_GET:
      localStorage.setItem('bookingSessionId', JSON.stringify(action.payload));
      return {
        ...state,
        bookingSessionId: action.payload,
      }
    case Actions.BOOKING_NOTES_GET:
      localStorage.setItem('bookingNotes', JSON.stringify(action.payload));
      return {
        ...state,
        bookingNotes: action.payload,
      }
    default:
      return state
  }
}
